export interface IPriceFormatter {
    currency: string;
    locale: string;
}

export class PriceFormatter {
    private currency: string;
    private locale: string;
    constructor(config: IPriceFormatter) {
        this.currency = config.currency;
        this.locale = config.locale;
    }

    public formatPriceWithCurrency = (price: number) => {
        return Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency
        }).format(price);
    };
}
